import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "template" ]

  connect() {
    this.updateOptions()
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    this.updateOptions()
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest('.nested-form-wrapper')

    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      wrapper.style.display = 'none'
      const destroyInput = wrapper.querySelector("input[name*='[_destroy]']")
      if (destroyInput) destroyInput.value = '1'
    }

    this.updateOptions()
  }
  
  updateOptions() {
    const selects = Array.from(this.containerTarget.querySelectorAll("select"))
    const selectedValues = selects
      .filter(select => {
        const wrapper = select.closest('.nested-form-wrapper')
        const destroyInput = wrapper ? wrapper.querySelector("input[name*='[_destroy]']") : null
        return !destroyInput || destroyInput.value !== '1'
      })
      .map(select => select.value)
      .filter(val => val !== "")

    selects.forEach(currentSelect => {
      const currentValue = currentSelect.value

      Array.from(currentSelect.options).forEach(option => {
        if (option.value === "") return
        if (selectedValues.includes(option.value) && option.value !== currentValue) {
          option.disabled = true
          option.style.display = "none" 
        } else {
          option.disabled = false
          option.style.display = ""
        }
      })

      if (window.jQuery && $(currentSelect).data('select2')) {
        $(currentSelect).trigger('change.select2')
      }
    })
  }
}
